import type { Component } from './types';

import React from 'react';

import { Button } from '@sgcmpteltd/uikit-react';
import { Loader2 } from 'lucide-react';

import { customButtonVariant } from './configs';

import { cn } from '@/lib/utils';

export const CustomButton: Component = ({
  children,
  className,
  isInvalid = false,
  isLoading,
  ...props
}) => {
  const variant = props.variant || 'contained';
  const color = props.color || 'red';

  return (
    <Button
      className={cn(
        'px-8 py-[0.8rem] justify-center !text-sm !leading-[1] flex items-center gap-[0.4rem]',
        'disabled:!bg-gray-400 disabled:!border-gray-400 disabled:!text-gray-800 transition-colors',
        className,
        {
          '!bg-red-50 hover:!bg-red-50 !border-red-500 !text-red-500': isInvalid,
        },
        customButtonVariant({ color, variant }),
      )}
      {...props}
    >
      {isLoading && <Loader2 className="animate-spin" size={18} />}
      {children}
    </Button>
  );
};
